import { createAction, props } from '@ngrx/store';

import { Site } from '@shared/models';

export const setActiveSite = createAction('[Site] Set Active Site', props<{ id: number }>());

export const setActiveSiteSuccess = createAction('[Site] Set Active Site Success', props<{ data: Site }>());

export const setActiveSiteFailure = createAction('[Site] Set Active Site Failure', props<{ error: any }>());

export const updateSiteFailure = createAction('[Site] Update Site Failure', props<{ error: any }>());

export const clearSiteState = createAction('[Site] Clear Site State');
